import BaseCollection from "nexia_mobile/models/base_collection";
import { ResourceMap } from "nexia_mobile/framework/resource";
import Phone from "nexia_mobile/models/phone";
import Schema from "nexia_mobile/models/schema";

export default class PhoneCollection extends BaseCollection {
  model = Phone;

  // We don't call super here because that always creates new models, which updates
  // the ResourceMap when we don't want it to. Reproduce most of the logic instead.
  parse(attrs) {
    let items = this._performParseSideEffects(attrs);
    // Pierce our "links" abstraction to reuse models when possible
    function getId(item) {
      return item && item._links && item._links.self && item._links.self.href;
    }
    return items.filter(getId).map((item) => {
      const id = getId(item);
      let existingPhone = ResourceMap.findByHref(id);
      if (existingPhone) {
        return existingPhone.set(existingPhone.parse(item));
      } else {
        // eslint-disable-next-line babel/new-cap
        return new this.model(item, { parse: true });
      }
    });
  }

  parseLinksChildSchema(links) {
    this.childSchemaLink = links[0];
  }

  getChildSchema() {
    const schema = new Schema();
    if (this.childSchemaLink == null) {
      return Promise.reject(
        new Error(
          "Cannot get child schema on phones collection with no child schema link"
        )
      );
    }
    schema.setUrl(this.childSchemaLink.href);
    return schema.fetch().then(() => schema);
  }
}



// WEBPACK FOOTER //
// ./src/models/phone_collection.js